import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

export default function FeastAuth() {

const [email, setEmail] = useState(""); 
const [password, setPassword] = useState("");
const [adminData, setAdminData] = useState({});
  const navigate = useNavigate();

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://backend.sanchalansetu.com/api/v1/login', {  
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
      const result = await response.json();

      if (!response.ok || !result.response) {
        toast.warn(result.message || "Login failed");
        return;
      }
/*       if (result.role_id > 3) {

        toast.error("You are not authorized to access this application.Only Admin , Execution Head Can Access This Application.");

      } else {
 */
        const userDepartment = result.user.department_id || 1;
        localStorage.setItem("UserDepartment", userDepartment);
      setAdminData(result.user);

      const token = result.token || generateUUID();
      localStorage.setItem("authToken", token);
      localStorage.setItem("UserName", result.name || "Admin");
      localStorage.setItem("UserAvatar", result.user.avatar || "");
      localStorage.setItem("UserRole", result.role_id || 1);
      localStorage.setItem("UserId", result.user.id || 1);
      setEmail("");
      setPassword("");
      if(userDepartment === 1){
       navigate("/");
      }else{
        navigate("/task-details");
      }
      toast.success(result.message);
      
    } catch (error) {
      console.error("Login error:", error);
      alert("Something went wrong. Please try again.");
    }
  };


  return (
    <div className="relative flex h-screen font-sans">

      <div className=" bg-red-500 flex justify-center items-center text-white  Login-left-side">
        <div className="">
          <div>
            {/* <h1 className="text-6xl font-bold">Sanchalan setu</h1> */}
            {/* <p className="text-lg mt-2">Stay Organized , Stay Ahead with Sanchalan setu.</p> */}
          </div>
          
        </div>
      </div>

      {/* Right Side */}
      <div className="flex justify-center Login-right-side">
        <div className="  p-10 mt-16 w-auto">
          <div className="flex justify-center item-center"><img src="/Main-logo.png" alt="Logo" srcset="" className="w-20 h-20 "/></div>
          <h1 className=" text-5xl font-bold mb-2 text-center" style={{ textShadow: "1px 1px 2px black" ,color:"#2E318F"}}>Sanchalan setu</h1>
          <p className="text-lg mt-2 mb-10">Organized Management, Stay Ahead with Sanchalan setu.</p>

          <h2 className="text-xl font-semibold mt-8 mb-10 text-center">Admin Credentials</h2>

          <form className="flex flex-col space-y-8">
            <input
              type="text"
              placeholder="Email"
              className="border text-black rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 text-left outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              className="border rounded-lg text-black px-4 py-2 focus:ring-2 focus:ring-blue-500 text-left outline-none"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="button"
              onClick={handleLogin}
              className=" text-white w-full py-2 rounded-lg font-semibold  transition" style={{backgroundColor:"#2E318F"}} onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#4a4cc2ea")} onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#2E318F")}
            >
              Login
            </button>
          </form>
        </div>
      </div>

      
      
    </div>
  );
}
